module.exports = "<span>\n    <select>\n    </select>\n </span>\n";